export enum InvoiceGenSchedule {
  NIGHTLY = 'Nightly',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly'
}
